import React from 'react';

const TextAreaInput = ({
  label,
  name,
  id,
  value,
  onChange,
  required = false,
  disabled = false,
  placeholder = '',
  rows = 3,
  className = '',
  error,
}) => {
  const baseClasses = "shadow appearance-none border rounded w-full py-2 px-3 bg-gray-700 text-text-white leading-tight focus:outline-none focus:shadow-outline";
  const errorClasses = error ? "border-red-500" : "border-border-subtle";

  return (
    <div className="mb-4">
      <label className="block text-text-gray text-sm font-bold mb-2" htmlFor={id}>
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <textarea
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        rows={rows}
        className={`${baseClasses} ${errorClasses} ${className}`}
      ></textarea>
      {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
    </div>
  );
};

export default TextAreaInput;